/* eslint-disable */
import { createContext, useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Mixpanel } from "../Mixpanel";

const AuthContext = createContext({
  auth: {},
  onLogout: () => { },
  onLogin: (email, pasword) => { },
  baseUrl: "",
  loginUrl: "",
  ssoConsumeUrl: "",
  resetUrl: "",
  forgotUrl: "",
  logoutUrl: "",
  signupUrl: "",
  verifyAccount: "",
  verifyTemp: "",
});

let tempUrl = `${window.location.href}`;
let baseUrl = "";
let loginUrl = "";
let ssoConsumeUrl = "";
let resetUrl = "";
let forgotUrl = "";
let signupUrl = "";
let verifyAccount = "";
let verifyTemp = "";

if (tempUrl.search("localhost") > 0) {
  // baseUrl = "http://65.2.187.195/zap-php/zap-php-new/api/";
  // baseUrl = "http://localhost/zap-php-new/api/";
  // baseUrl = "https://devadmin.askzoi.com/api/";
  baseUrl = "https://dev1.askzoi.com/api/";
  // baseUrl = "https://nimf1.askzoi.com/api/";
} 
else if (tempUrl.search("dev.askzoi.com") > 0) {
  baseUrl = "https://dev1.askzoi.com/api/";
} else if (tempUrl.search("sia.technochimes.com") > 0) {
  baseUrl = "https://staging1.askzoi.com/api/";
} else if (tempUrl.search("sia.salespanda.com") > 0) {
  baseUrl = "https://siaadmin.salespanda.com/api/";
} else if (tempUrl.search("smartmfdpro.askzoi.com") > 0) {
  baseUrl = "https://smartmfdpro1.askzoi.com/api/";
} else if (tempUrl.search("sia.nimfpartners.com") > 0) {
  baseUrl = "https://sia1.nimfpartners.com/api/";
} else if (tempUrl.search("nimf.askzoi.com") > 0) {
  baseUrl = "https://nimf1.askzoi.com/api/";
} else if (tempUrl.search("sia.nimfpartners.com") > 0) {
  baseUrl = "https://sia1.nimfpartners.com/api/";
}else {
  // baseUrl = window.location.href;
  // baseUrl =
  //   baseUrl.split("/")[0] +
  //   "/" +
  //   baseUrl.split("/")[1] +
  //   "/" +
  //   baseUrl.split("/")[2] +
  //   "/";
  baseUrl = "https://dev1.askzoi.com/api/";
}
resetUrl = baseUrl + "resetPassword"
loginUrl = baseUrl + "login";
forgotUrl = baseUrl + "forgotPassword";
signupUrl = baseUrl + "register";
verifyAccount = baseUrl + "verifyEmail";
verifyTemp = baseUrl + "verify-temp-user";
ssoConsumeUrl = baseUrl + "sso/consume";

export const AuthProvider = (props) => {
  const [userData, setUserData] = useState({});

  useEffect(() => {
    if (localStorage.getItem("userData")) {
      const storedUserData = JSON.parse(localStorage.getItem("userData"));
      if (storedUserData !== {}) {
        setUserData(storedUserData);
      }
    }

  }, []);

  const loginDataHanlder = (data) => {
    localStorage.setItem("appType", "AssetLibrary");
    localStorage.setItem("userData", JSON.stringify(data));
    localStorage.setItem("authToken", JSON.stringify(data.token));
    localStorage.setItem("userType", JSON.stringify(data.data.user_type));
    
   // Cookies.set("SPSESSTKN", data.token);
    setUserData(data);
    Mixpanel.people.set({
      $first_name: data?.data?.first_name,
      $last_name: data?.data?.last_name,
      $email: data?.data?.email
    });
    Mixpanel.identify(data?.data?.id);
    // window.clarity("identify",data?.data?.email);
    const idString = data?.data?.id.toString()
    window.clarity("set","zoiID",idString);
    window.clarity("set","email",data?.data?.email);
    window.clarity("set","source","zoiAdmin");
  };

  const logoutHandler = () => {
    localStorage.clear();
    // Cookies.remove("SPSESSTKN");
    setUserData(null);
    // window.location.reload();
    window.location = window.location.origin
  };

  return (
    <AuthContext.Provider
      value={{
        auth: userData ? userData.token : null,
        loginUrl: loginUrl,
        signupUrl: signupUrl,
        forgotUrl: forgotUrl,
        resetUrl: resetUrl,
        verifyAccount: verifyAccount,
        verifyTemp: verifyTemp,
        ssoConsumeUrl: ssoConsumeUrl,
        onLogout: logoutHandler,
        onLogin: loginDataHanlder,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
